<template>
  <div class="order" :style="bannerFlag ? 'margin-top: 56px;' : ''">
    <div class="order-box w" style="min-height: calc(100vh - 125px);">
      <!-- 步骤标题 -->
      <div class="order-step">
        <div class="order-step-wrap" v-for="(item, i) in stepList" :key="i"
          :class="item.stepList.includes(currentStep+'') ? 'step-active' : ''">
          <i :class="item.icon" style="font-size: 18px;"></i>
          <span>{{ item.name }}</span>
        </div>
      </div>

      <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)"
        style="min-height: calc(100vh - 220px);">
        <!-- 选中显示标题 -->
        <div class="order-title">
          {{ form.demName }} {{ catalogTitle }} <span v-if="currentStep != 1 && form.demPatient">【{{ form.demPatient}}】</span>
        </div>

        <!-- 步骤一 -->
        <div class="order-detail-catalog" style="min-height: calc(100vh - 313px);" v-if="currentStep === 1">
          <!-- 主目录 -->
          <section class="order-catalog">
            <ul class="box">
              <li class="content" v-for="(item, i) in catalogList" :key="i" @click="changeMainCatalog(i)"
                :class="currentCatalog === i ? 'active' : ''">
                <img class="i" :src="item.iconSelect" v-if="currentCatalog === i">
                <img class="i" :src="item.icon" v-else>
                <span>{{ item.name }}</span>
                <a class="cover-link"></a>
              </li>
            </ul>
          </section>
          <!-- 子目录 -->
          <section class="order-sub-catalog">
            <ul class="box">
              <li class="content" v-for="(item, j) in subCatalogList" :key="j" @click="changeSubCatalog(j)"
                :class="currentSubCatalog === j ? 'active' : ''"
                :id="currentCatalog == 0 && user.demServType != '00' ? 'clinic' : 'factory'">
                <div class="sub-box">
                  <img class="i" :src="item.icon">
                  <span>{{ item.name }}</span>
                  <a class="cover-link"></a>
                </div>
              </li>
            </ul>
          </section>
        </div>
        <!-- 步骤二 -->
        <div class="order-detail-design" style="min-height: calc(100vh - 313px);"
          v-if="currentStep === 2 && subCatalogId != '3010130'">
          <div class="order-design-image" ref="tooth" style="margin-top: 30px;background-color: #F7F7F7;">
            <DTooth ref="toothComponent" @changeTooth="changeOrderCount" :adjunct="adjunct" :teethList="teethList"
              :steelList="steelList" :glueList="glueList" style="margin-left:-10px;padding-bottom: 50px;"></DTooth>
          </div>
          <div class="order-design-info">
            <!-- 1、基本信息 -->
            <div class="order-basic-wrap">
              <base-tag label="基本信息" style="position: relative;"></base-tag>
              <input-field inputClass="contact" :label="'下单名称'" v-model="form.demContact"
                :customStyle="{ '--inputColorContact': colorContact }"
                :readonly="user.demServType == '00' ? true : false" @input="change1" required />
              <input-field inputClass="phone" label="联系方式" v-model="form.demPhone"
                :customStyle="{ '--inputColorPhone': colorPhone }" :readonly="false" @input="change2" required />
              <input-field inputClass="patient" label="患者姓名" v-model="form.demPatient"
                :customStyle="{ '--inputColorPatient': colorPatient }" :readonly="false" @input="change3" required />
              <select-field label="患者性别" v-model="form.demSex" :options="demSexMap" placeholder="请选择性别" required
                style="line-height: 40px;" />
            </div>
            <!--2、设计费详情 -->
            <div class="order-input-wrap">
              <base-tag label="设计费详情"></base-tag>
              <input-field label="数量" v-model="form.orderCount" :readonly="true" required />
              <input-field label="单价" v-model="form.orderPrice" :readonly="true" required />
              <input-field label="钢牙数量" v-model="form.steelCount" :readonly="true" required
                v-if="form.steelCount > 0" />
              <input-field label="钢牙单价" v-model="form.steelPrice" :readonly="true" required
                v-if="form.steelCount > 0" />
              <input-field label="充胶牙数量" v-model="form.glueCount" :readonly="true" required v-if="form.glueCount > 0" />
              <input-field label="充胶牙单价" v-model="form.gluePrice" :readonly="true" required v-if="form.glueCount > 0" />
              <input-field label="精密附件数量" v-model="form.enclosureCount" :readonly="true" required
                v-if="form.enclosure != ''" />
              <input-field label="精密附件单价" v-model="form.enclosurePrice" :readonly="true" required
                v-if="form.enclosure != ''" />
              <select-field v-if="isLevel" label="设计师级别" v-model="form.desLevel" :options="desLevelMap"
                placeholder="请选择设计师级别" @input="calAmount" />
              <input-number-field label="是否加急(元)" v-model="form.orderRushFee" @input="calAmount"
                :disabled="isEditServOrder == '1'" :isEditServOrder="isEditServOrder" required />
              <input-field label="总价" v-model="form.orderAmount" :readonly="true" required style="margin-top: -5px;" />
            </div>
            <!-- 3、设计需求 -->
            <div class="order-input-wrap">
              <base-tag label="设计需求"></base-tag>
              <!-- 区别局部/全口 局部用 附件/全口用 设计类型-->
              <select-field label="下单类型" v-model="form.designTray" :options="annexMap" placeholder="请选择设计类型" required
               @change="changeDesignTray" v-if="['4010120'].includes(subCatalogId)" />
              <div class="input-form-wrap" style="margin-left:3.5%;width: 47%;"
                v-if="['4010110'].includes(subCatalogId)">
                <div class="input-label">
                  <span>精密附件：</span>
                </div>
                <el-input class="input-form" v-model="form.enclosure" size="mini" @input="changeAnnex"
                  placeholder="选填" style="margin-left: 3.5%;" />
              </div>
              <div class="input-form-wrap" style="width: 56%;margin: 2% 0 0 20px;" v-if="['4010110'].includes(subCatalogId)">
                <div class="input-label">
                  <span>附件</span>
                </div>
                <el-radio v-model="adjunct" label="00" style="margin-left: -30px;">无附件</el-radio>
                <el-radio v-model="adjunct" label="01">钢牙</el-radio>
                <el-radio v-model="adjunct" label="02">充胶牙</el-radio>
              </div>
              <div :style="subCatalogId=='4010110'?'margin-top: 5px;':'margin-top: 10px;'">
                <el-button type="primary" style="width:100px;margin-left: 27px;" size="mini" plain @click="resetTeeth">重置牙位</el-button>
                <el-button type="primary" style="width:100px;margin-left: 27px;" size="mini" plain @click="undoTeeth">撤销</el-button>
              </div>
            </div>

            <!--7、备注信息 -->
            <div class="order-input-wrap">
              <base-tag label="备注信息"></base-tag>
              <div class="input-textarea">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 20 }" placeholder="请输入备注信息"
                  v-model="form.orderRemark" />
              </div>
            </div>
            <div class="order-input-wrap" v-if="remarkHistory.length != 0">
              <base-tag label="快捷标签"></base-tag>
              <div class="item-history">
                <el-tag v-for="(item, index) in remarkHistory" :key="index" @click="replaceStr(index)"
                  @close="removeItem(index)" closable style="margin: 5px 5px;">{{ item }}</el-tag>
              </div>
            </div>
          </div>
        </div>
        <!-- 步骤三 编辑选择后的牙位图 -->
        <div class="order-detail-upload" style="min-height: calc(100vh - 313px);" v-if="this.currentStep === 3">
          <el-button type="primary" plain @click="changeEdit" size="mini"
          style="width: 120px;margin-left: 44%;" v-if="!editCanvas"
          >重新编辑</el-button>
          <canvasBracket :canvasImgUrl="canvasImgUrl" @canvasImg="canvasToothImg" @ruleFlag="corrective" v-if="editCanvas"/>
          <img :src="designActiveImg" style="width: 570px;height: 620px;margin-left: 25%;" v-else>
        </div>
        <!-- 步骤四 上传数据 -->
        <div class="order-detail-upload" style="min-height: calc(100vh - 313px);" v-if="currentStep === 4">
          <div class="input-type-wrap" v-if="common.serv.get(subCatalogId).isDataType == '1' || common.serv.get(subCatalogId).isSoftType == '1'">
            <base-tag label="数据信息"></base-tag>
            <div class="input-form-wrap" v-if="common.serv.get(subCatalogId).isDataType == '1'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>数据类型</span>
              </div>
              <el-select class="input-select" v-model="form.dataType" placeholder="请选择数据类型" size="mini">
                <el-option class="option-item" v-for="item in common.dict.get('biz_scan_type')" :key="item.value"
                  :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <div v-if="form.dataType == '99'">
                <el-input class="input-form" v-model="form.otherDataType" placeholder="请输入数据类型" size="mini" />
              </div>
            </div>
            <div class="input-form-wrap" v-if="common.serv.get(subCatalogId).isSoftType == '1'">
              <div class="input-label">
                <span style="color:red">*</span>
                <span>扫描仪品牌</span>
              </div>
              <el-select class="input-select" v-model="form.softType" placeholder="请选择软件种类" size="mini">
                <el-option class="option-item" v-for="item in common.dict.get('biz_soft_type')" :key="item.value"
                  :label="item.label" :value="item.value" />
              </el-select>
              <div v-if="form.softType == '99'">
                <el-input class="input-form" v-model="form.otherSoftType" placeholder="请输入扫描仪品牌" size="mini" />
              </div>
            </div>
          </div>
          <!-- 口扫数据 -->
          <div class="input-upload-wrap" v-if="common.serv.get(subCatalogId).isScanData == '1'">
            <base-tag label="扫描数据"></base-tag>
            <div class="order-upload-wrap">
              <div class="order-file-wrap">
                <el-upload class="upload-file" action :before-upload="handleChange" :http-request="uploadFile"
                  :before-remove="beforeRemove" :on-remove="(file, fileList) => { handleRemove(file, fileList, '07') }"
                  :data="{ objectType: '07', objectTag: subCatalogId + '_' + form.demPatient }" :file-list="dataScan"
                  :on-exceed="handleExceed" :auto-upload="true" :limit="5" multiple>
                  <div class="upload-file-dragger1">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
          <!-- 扫描杆数据库 -->
          <div class="input-upload-wrap" v-if="form.enclosure.length > 0">
            <base-tag label="精密配件数据库"></base-tag>
            <div class="order-upload-wrap">
              <div class="order-file-wrap">
                <el-upload class="upload-file" action :before-upload="handleChange" :http-request="uploadFile"
                  :before-remove="beforeRemove" :on-remove="(file, fileList) => { handleRemove(file, fileList, '22') }"
                  :data="{ objectType: '22', objectTag: subCatalogId + '_' + form.demPatient }"
                  :file-list="dataAccessory" :on-exceed="handleExceed" :auto-upload="true" :limit="5" multiple>
                  <div class="upload-file-dragger1">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order-ops">
        <y-button text="重新创建" classStyle="main-btn ml" @btnClick="clickReSelect" v-if="currentStep === 2"></y-button>
        <y-button text="上一步" classStyle="main-btn ml" @btnClick="clickPreStep"
          v-if="[3, 4].includes(currentStep)"></y-button>
        <y-button text="下一步" :classStyle="nextStep ? 'main-btn ml' : 'disabled-btn ml'" @btnClick="clickNextStep"
          v-if="currentStep != 4"></y-button>
        <y-button :text="isEditServOrder == '1' ? '修改提交' : '生成订单'" classStyle="main-btn ml" @btnClick="submitUpdate"
          v-if="isEditServOrder == '1' || currentStep == 4"></y-button>
      </div>
    </div>
    <Customer class="customerSer"></Customer>
    <el-dialog center title="进度留言" width="30%" :visible.sync="msgDialog" :modal-append-to-body="false"
      :destroy-on-close="true" :lock-scroll="false">
      <el-form label-position="left" :model="ruleForm" ref="ruleForm">
        <el-form-item prop="content" label="留言内容:" label-width="120px">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" v-model="ruleForm.content"
            placeholder="请填写留言内容内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="msgDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">继续制作</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'
import {
  getStore
} from '/utils/storage'
// 局部引入
import catalogList from "/assets/config/order/catalogList.js";
import DTooth from '/components/DTooth';
import YButton from '/components/YButton';
import BaseTag from '/components/BaseTag';
import InputNum from '/components/inputNum';
import BuyNum from '/components/buynum';
import Customer from '../components/customerSer';
import InputField from '../components/orderCreate/InputField';
import SelectField from '../components/orderCreate/SelectField';
import InputNumberField from '../components/orderCreate/InputNumberField';
import RadioField from '../components/orderCreate/RadioField';
import CanvasBracket from './canvasBracket';
import {
  uploadByPieces
} from "../../../../common/upload.js";
import graceChecker from '../../../../common/graceChecker.js';
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      //动态改变文字颜色
      colorContact: '',
      colorPhone: '',
      colorPatient: '',
      colorOrderCount: '',
      colorOrderAmount: '',

      userId: '',
      bannerFlag: false,
      loading: true,
      currentStep: 1,
      nextStep: false,
      stepList: [{
        "stepList": ["1"],
        "name": "服务选择",
        "status": -1,
        "icon": "el-icon-thumb"
      },
      {
        "stepList": ["2", "3"],
        "name": "设计信息",
        "status": 0,
        "icon": "el-icon-edit"
      },
      {
        "stepList": ["4"],
        "name": "数据上传",
        "status": 0,
        "icon": "el-icon-upload"
      }
      ],
      currentCatalog: -1,
      currentSubCatalog: -1,
      catalogList: [],
      subCatalogList: [],
      catalogId: '',
      subCatalogId: '',
      catalogTitle: '',
      adjunct: '00',//附件选择
      form: {
        /** 发单方诊所/工厂名称 */
        demName: '',
        /** 发单方联系人 */
        demContact: '',
        /** 发单方联系方式 */
        demPhone: '',
        /** 患者名称 */
        demPatient: '',
        /** 设计师等级 01=初级,02=中级,03=高级,99=认证级 */
        desLevel: '01',
        /** 数量 */
        orderCount: 0,
        toothCountAll: 0,//牙位总数
        /** 单价 */
        orderPrice: 0.00,
        /** 是否加急 0=否,1=是 */
        /** 加急费 */
        orderRushFee: 0.00,
        /** 订单总价 */
        orderAmount: 0.00,
        /** 订单备注 */
        orderRemark: '',
        /** 软件种类 */
        softType: '',
        otherSoftType: '',
        /** 数据类型 */
        dataType: '',
        otherDataType: '',
        /** 牙位-单冠 */
        posSingle: '',
        /** 牙位-连桥 */
        posBridge: '',
        // 是否编辑模型文件
        isEditScanModel: '0',
        /** 设备型号 */
        demSex: '',
        // 牙位附件材质
        enclosure: '',
        // 4010120 设计类型
        designTray: '00',
        // 钢牙数量
        steelCount: 0,
        // 钢牙单价
        steelPrice: 0.00,
        // 充胶牙数量
        glueCount: 0,
        // 充胶牙单价
        gluePrice: 0.00,
        // 精密附件数量
        enclosureCount: 0,
        // 精密附件单价
        enclosurePrice: 0.00,
      },
      // 留言表单
      ruleForm: {
        content: ''
      },
      isEditServOrder: '0', //新增订单or修改订单
      formData: "",
      /** 口扫数据 */
      dataScan: [],
      /** 设计单照片 */
      dataSheet: [],
      /** 口内照片 */
      dataMouth: [],
      /** CBCT数据 */
      dataCbct: [],
      /** 扫描杆数据 */
      dataScanRod: [],
      /** 精密附件数据 */
      dataAccessory: [],
      fileList: [],
      teethList: [],//默认牙位
      steelList: [],//钢牙列表
      glueList: [],//充胶牙列表
      cateserv: null, // 服务单参数详情
      fileNum: 0, //上传文件数量
      prohibit: false,
      selectFileCount: 0,
      successFileCount: 0,
      upSelect: '', //选择上颌
      downSelect: '', //选择下颌
      desLevelMap: [], //工厂端设计师等级
      isLevel: false, //设计师级别是否显示
      remarkHistory: [], //备注历史列表
      // 动态类名
      msgDialog: false, //修改订单留言框status
      isCreate: false, //创建订单的状态还是修改订单的状态，传递给tooth组件
      canvasImgUrl: '',//截图图片存储地址
      ruleFlag:false,//判断画布url的表单验证状态
      editCanvas: true,//判断是否编辑画布
      designActiveImg:'',//存储画布图片
      demSexMap: [{
        value: '00',
        label: '男'
      },
      {
        value: '01',
        label: '女'
      }
      ],
      //附件类型
      annexMap: [
        {
          value: '00',
          label: '个别托盘设计'
        },
        {
          value: '01',
          label: '暂基托设计'
        },
        {
          value: '02',
          label: '总义齿设计'
        }
      ],
    }
  },
  computed: {
    ...mapState(['common', 'user']),
    editScanModelText() {
      const price = this.common.serv.get(this.subCatalogId).editScanModelBprice || 0;
      return `编辑模型文件${price}元`;
    },
  },
  methods: {
    //获取牙位图
    getPrintScreen() {
      if (this.$refs.tooth) {
        // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
        html2canvas(this.$refs.tooth, {
          // width: 30, //截图宽度
          // height: 50, //截图高度
          backgroundColor: null, //画出来的图片有白色的边框,不要 可设置背景为透明色（null）
          useCORS: true, //支持图片跨域
          scale: window.devicePixelRatio || 2, // 使用设备像素比或默认值
        }).then((canvas) => {
          // 把生成的base64位图片上传到服务器,生成在线图片地址
          let url = canvas.toDataURL("image/png") // toDataURL: 图片格式转成 base64
          this.canvasImgUrl = url;
          sessionStorage.setItem('canvasImgUrl', this.canvasImgUrl);
        })
      }
    },
    changeMainCatalog(index) {
      // 切换当前主目录
      this.currentCatalog = this.currentCatalog === index ? -1 : index;
      // 如果没有选择主目录，则清空子目录列表
      if (this.currentCatalog === -1) {
        this.subCatalogList = [];
        return;
      }
      this.getSubCatalogList(this.currentCatalog);
    },
    //选择子目录时调用
    changeSubCatalog(index) {
      this.currentSubCatalog = this.currentSubCatalog === index ? -1 : index;
      if (this.currentStep === 1) {
        this.checkCatalogNextStep();
      }
      this.removeSession();
    },
    checkCatalogNextStep() {
      if (this.currentCatalog != -1 && this.currentSubCatalog != -1) {
        this.nextStep = true;
        this.catalogId = this.catalogList[this.currentCatalog].catalogId;
        this.subCatalogId = this.catalogList[this.currentCatalog].subCataLog[this.currentSubCatalog].subCatalogId;
        this.catalogTitle = this.catalogList[this.currentCatalog].name + ' - ' + this.catalogList[this.currentCatalog].subCataLog[this.currentSubCatalog].name;
      } else {
        this.nextStep = false;
        this.catalogId = '';
        this.subCatalogId = '';
        this.catalogTitle = '';
      }

      if (this.subCatalogId != '') {

        this.cateserv = this.common.serv.get(this.subCatalogId)

        // 初始化订单数量
        if (this.subCatalogId === '4010110') {
          this.form.orderCount = 1;
        }
        // 初始化加急费
        this.form.orderRushFee = 0.00;
        this.form.dataType = '06'
        this.form.softType = '01'
        this.common.dict.get('biz_scan_type').sort((a, b) => a.sort - b.sort)
        this.common.dict.get('biz_soft_type').sort((a, b) => a.sort - b.sort)
        this.calAmount();
      }

    },
    // 编辑附件内容
    changeAnnex() {
      this.form.enclosureCount = this.form.enclosure != '' ? 1 : 0;
      this.calAmount();
      sessionStorage.setItem('enclosure', this.form.enclosure)
    },
    /**
     * 计算数组所有元素总和
     * @param {array} array 需要计算的数组
     * @returns {number} 元素总和
     */
    calTotalLength(array) {
      let total = 0;
      array.forEach(item => {
        if (Array.isArray(item)) {
          total += this.calTotalLength(item); // 递归调用
        } else {
          total += 1; // 非数组项，视为一个元素
        }
      });
      return total;
    },
    changeOrderCount(toothList, steelList, glueList) {
      var id = this.subCatalogId;
      // 赋值牙位
      this.form.posSingle = toothList;
      this.teethList = toothList;
      this.steelList = steelList;
      this.glueList = glueList;
      sessionStorage.setItem('teethList', JSON.stringify(this.teethList));
      sessionStorage.setItem('steelList', JSON.stringify(this.steelList));
      sessionStorage.setItem('glueList', JSON.stringify(this.glueList));
      // 处理牙位数量
      // 单个RPD支架数量
      this.form.steelCount = steelList.length;
      this.form.glueCount = glueList.length;
      this.form.orderCount = toothList.length > 0 || this.form.steelCount > 0 || this.form.glueCount > 0 ? 1 : 0;
      // 数量/总价改变颜色
      if (this.form.orderCount > 0) {
        this.colorOrderCount = '#2979ff';
        this.colorOrderAmount = '#2979ff';
      }
      this.showLevel(id);
      this.calAmount();
      sessionStorage.setItem('form', JSON.stringify(this.form));

      this.judgeTeeth();
    },
    // 传入牙位，判断是否是全部牙位
    judgeAllTeeth(){
      //上颌11-27  下颌31-47
      let topStart = 11;
      let topEnd = 27;
      let bottomStart = 31;
      let bottomEnd = 47;
      let up = false;
      let down = false;
      let count = this.form.posSingle.length>0||this.steelList.length>0||this.glueList.length>0?1:0;
      for(let i = topStart;i<=topEnd;i++){
        if(this.form.posSingle.includes(i)){
          up = true;
        }
        if(this.steelList.includes(i)){
          up = true;
        }
        if(this.glueList.includes(i)){
          up = true;
        }
      }
      for(let i = bottomStart;i<=bottomEnd;i++){
        if(this.form.posSingle.includes(i)){
          down = true;
        }
        if(this.steelList.includes(i)){
          down = true;
        }
        if(this.glueList.includes(i)){
          down = true;
        }
      }
      if(up&&down){
        this.form.orderCount = 2;
      }else{
        this.form.orderCount = count;
      }
    },
    calAmount() {
      let id = this.subCatalogId;
      if (this.cateserv == null || this.cateserv.length == 0) {
        this.cateserv = this.common.serv.get(id);
      }
      if(this.form.designTray!='02'){
        this.form.orderPrice = parseFloat(this.cateserv.clnBprice).toFixed(2);
      }
      this.form.steelPrice = parseFloat(this.cateserv.steelTeeth).toFixed(2);
      this.form.gluePrice = parseFloat(this.cateserv.rubberFilledTeeth).toFixed(2);
      this.form.enclosurePrice = parseFloat(this.cateserv.precisionAccessories).toFixed(2);
      // 判断上下颌
      this.judgeAllTeeth();

      // 订单总数
      // this.form.toothCountAll = this.form.orderCount;
      // 订单金额 数量*单价+钢牙*钢牙单价+充胶牙数量*充胶牙单价+精密附件价格
      this.form.orderAmount = this.form.orderCount * parseInt(this.form.orderPrice) + this.form.steelCount * parseInt(this.form.steelPrice) + this.form.glueCount * parseInt(this.form.gluePrice) + this.form.enclosureCount * parseInt(this.form.enclosurePrice);

      //加急费
      if (this.form.orderRushFee != 0.00) {
        let orderAmount = Number(this.form.orderAmount) || 0;
        let orderRushFee = Number(this.form.orderRushFee) || 0;
        this.form.orderAmount = orderAmount + orderRushFee;
      }
      // 金额小数点后两位
      this.form.orderAmount = parseFloat(this.form.orderAmount).toFixed(2);
    },
    // 控制按钮 - 重新选择
    clickReSelect() {
      this.resetForm();
      this.upSelect = 0;
      this.downSelect = 0;
      this.currentStep = 1;
      this.isCreate = false;
      this.nextStep = false;
      this.ruleFlag = false;
      this.adjunct = '00';
      this.designActiveImg = [];
      this.form.toothCountAll = 0;
      this.form.isEditScanModel = '0';

      this.removeSession();
      this.loadOrderParam();
      this.$router.push({
        path: '/order/create',
      })
    },
    // 按钮控制 - 下一步
    clickNextStep() {
      this.form.desLevel = '01'
      let id = this.subCatalogId;
      this.common.dict.get('biz_des_level').pop();
      sessionStorage.setItem('catalogId', this.catalogId)
      sessionStorage.setItem('catalogTitle', this.catalogTitle)
      if (this.checkValid(this.currentStep) || this.currentStep == 1) {
        if (this.currentStep == 1) {
          if (['3010130', '4010110'].includes(id)) {
            let url = ['3010130'].includes(id) ? '/order/orthodonticsCreateOrder' : '/order/active/bracket';
            this.$router.push({
              path: url,
            })
          } else {
            this.isCreate = true;
            this.form.demContact = this.user.nickName
            this.isEditScanModel = '0'
            sessionStorage.setItem('cateserv', JSON.stringify(this.cateserv))
          }
        }
        sessionStorage.setItem("isCreate", JSON.stringify(this.isCreate))
        sessionStorage.setItem("subCatalogId", this.subCatalogId)
        this.showLevel(id);
        if (this.currentStep == 2) {
          this.isCreate = this.designActiveImg!=''?false:true;
          this.editCanvas = this.isCreate? this.editCanvas : false;
          this.open();
          this.getPrintScreen();
        } else {
          this.currentStep += 1;
          sessionStorage.setItem('step', this.currentStep)
        }
      }
    },
    showLevel(id) {
      // 显示设计师级别
      if (this.user.demServType == '00' &&
        (id == '1010120' || id == '1010210' ||
          id == '1010220' || id == '1010310' ||
          id == '1010320' || id == '2010120' ||
          id == '2010210' || id == '2010220' ||
          id == '2010320' || id == '2010420')) {
        this.isLevel = true
      } else {
        this.isLevel = false
      }
      sessionStorage.setItem('isLevel', JSON.stringify(this.isLevel))
    },
    // 按钮控制 - 上一步
    clickPreStep() {
      this.currentStep -= 1;
      sessionStorage.setItem('step', this.currentStep)
      this.showLevel(this.subCatalogId)
    },
    // 重置订单下单方信息
    loadOrderParam() {
      this.form.demName = this.user.nickName;
      this.form.demContact = this.user.nickName;
      this.form.demPhone = this.user.mobile;
      this.form.dataType = '06';
      this.form.softType = '01'
    },
    message(m) {
      this.$message.error({
        message: m
      })
    },
    // 备注历史记录缓存
    remarkCache() {
      if (!this.remarkHistory.includes(this.form.orderRemark) && this.form.orderRemark != '') {
        this.remarkHistory.push(this.form.orderRemark)
      }
      if (this.remarkHistory.length > 10) {
        this.remarkHistory.splice(10, 1)
      }
      localStorage.setItem('remarkHistory', JSON.stringify(this.remarkHistory))
    },
    // 提交表单
    submitForm() {
      if (this.form.softType == '99' && this.form.otherSoftType == '') {
        this.$yxz.msg('请填写其他口扫品牌', 'error')
        return false;
      }
      let id = this.subCatalogId;
      if (this.checkValid(this.currentStep)) {
        let orderNo = ''
        if (sessionStorage.getItem('updateForm')) {
          orderNo = JSON.parse(sessionStorage.getItem('updateForm'))
        }
        // 拼接附件材质牙位到连桥
        this.handleAnnexTooth();
        let formData = new FormData();
        for (var key in this.form) {
          formData.append(key, this.form[key]);
        }
        this.formData = formData;
        this.addForm();
        this.remarkCache();
      }
    },
    // 修改订单打开留言dialog后的继续制作按钮
    submitUpdate() {
      if(this.form.enclosure&&this.dataAccessory.length==0){
        this.$message({
          type: 'error',
          message: '已填写精密附件，请上传精密附件数据库'
        })
        return false
      }
      if(this.designActiveImg.length == 0){
        this.$message({
          type: 'error',
          message: '已修改牙位，需重新上传牙位图'
        })
        return false
      }
      // 根据订单的状态，显示对应的内容提示
      if (this.isEditServOrder == '1' && JSON.parse(sessionStorage.getItem('updateForm')).orderStatus == '60') {
        this.msgDialog = true
      } else {
        this.msgDialog = false
        this.submitForm()
      }
    },
    async uploadFile({
      response,
      file,
      data
    }) {
      var loading = this.$loading({
        text: '等待上传完成，已上传 0%'
      });
      uploadByPieces({
        file: file, // 文件
        data: data,
        pieceSize: 3, // 分片大小
        concurrent: 3,
        process: res => {
          loading.setText('等待上传完成，已上传' + res + '%')
          // console.log('分片上传 -> process', res)
          // if (res == 100) {
          // loading.close();
          // }
        },
        success: res => {
          var temp = {
            url: res.data.url,
            name: file.name
          }
          if (data.objectType == '07') { //扫描数据
            this.dataScan.push(temp)
          } else if (data.objectType == '22') {//精密配件数据库
            this.dataAccessory.push(temp)
          }
          this.successFileCount += 1
          if (this.successFileCount == this.selectFileCount) {
            loading.close();
            this.selectFileCount = 0;
            this.successFileCount = 0;
          }
          // console.log('分片上传 -> success', res)
          this.sessionFile(this.dataScan, 'dataScan')
          this.sessionFile(this.dataSheet, 'dataSheet')
          this.sessionFile(this.dataMouth, 'dataMouth')
          this.sessionFile(this.dataCbct, 'dataCbct')
          this.sessionFile(this.dataScanRod, 'dataScanRod')
          this.sessionFile(this.dataAccessory, 'dataAccessory')
        },
        error: e => {
          this.selectFileCount = 0
          this.successFileCount = 0
          this.$yxz.msg('网络错误'.e, 'success')
          // console.log('分片上传 -> error', e)
        }
      })
    },
    // 如果上传文件 is not null 则存session
    sessionFile(val, name) {
      if (val != '') {
        sessionStorage.setItem(name, JSON.stringify(val))
      }
    },
    handleChange(file) {
      this.selectFileCount += 1
      return true;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList, type) {
      let name = ''
      let tempData = ''
      if (type == '07') {
        name = 'dataScan';
        tempData = this.dataScan;
      } else if (type == '22') {
        name = 'dataAccessory';
        tempData = this.dataAccessory;
      }
      if (tempData == '') {
        this.$message("数据错误！！")
        return false
      }
      for (let i = 0; i < tempData.length; i++) {
        if (file.name === tempData[i].name) {
          tempData.splice(i, 1);
        }
      }
      this.$message({
        type: 'success',
        message: '移除成功!'
      });
      this.fileNum -= 1
      this.sessionFile(name, tempData);
    },
    handleExceed() {
      this.$message({
        type: 'error',
        message: '最多支持5个文件上传'
      })
    },
    // 只保留上传文件url、name字段
    removeField(file) {
      let temp = []
      file.forEach(val => {
        let temp2 = {
          url: val.url,
          name: val.name
        }
        temp.push(temp2)
      })
      return temp;
    },
    //添加
    addForm() {
      var tempDataScan = [];
      var tempDataSheet = [];
      var tempDataMouth = [];
      var tempDataCbct = [];
      var tempDataScanRod = [];
      var tempDataAccessory = [];
      tempDataScan = JSON.stringify(this.removeField(this.dataScan))
      tempDataSheet = JSON.stringify(this.removeField(this.dataSheet))
      tempDataMouth = JSON.stringify(this.removeField(this.dataMouth))
      tempDataCbct = JSON.stringify(this.removeField(this.dataCbct))
      tempDataScanRod = JSON.stringify(this.removeField(this.dataScanRod))
      tempDataAccessory = JSON.stringify(this.removeField(this.dataAccessory))
      var orderData = {
        servCataId: this.subCatalogId,
        demName: this.formData.get('demName'),
        demContact: this.formData.get('demContact'),
        demPhone: this.formData.get('demPhone'),
        demSex: this.formData.get('demSex'),
        demPatient: this.formData.get('demPatient'),
        desLevel: this.formData.get('desLevel'),
        dataType: this.formData.get('dataType'),
        otherDataType: this.formData.get('otherDataType'),
        // 数量count
        orderCount: this.formData.get('orderCount'),
        orderPrice: this.formData.get('orderPrice'),
        softType: this.formData.get('softType'),

        orderRushFee: this.formData.get('orderRushFee'),
        orderAmount: this.formData.get('orderAmount'),
        orderRemark: this.formData.get('orderRemark'),
        posSingle: this.formData.get('posSingle'),
        posBridge: this.formData.get('posBridge'),
        isEditScanModel: this.formData.get('isEditScanModel'),
        dataScan: tempDataScan,
        dataSheet: tempDataSheet,
        dataMouth: tempDataMouth,
        dataCbct: tempDataCbct,
        // 暂时传递到扫描杆数据库中
        dataScanRod: tempDataScanRod,
      }
      var bracketData = {
        servCataId: this.subCatalogId,
        steelCount: this.formData.get('steelCount')?this.formData.get('steelCount'):0,
        glueCount: this.formData.get('glueCount')?this.formData.get('glueCount'):0,
        enclosureCount: this.formData.get('enclosureCount')?this.formData.get('enclosureCount'):0,
        // 单价price
        steelPrice: this.formData.get('steelPrice')?this.formData.get('steelPrice'):null,
        gluePrice: this.formData.get('gluePrice')?this.formData.get('gluePrice'):null,
        enclosurePrice: this.formData.get('enclosurePrice')?this.formData.get('enclosurePrice'):null,
        enclosure: this.form.enclosure ? this.formData.get('enclosure') : '',
        designTray: this.form.designTray && this.subCatalogId == '4010120' ? this.formData.get('designTray') : null,

        //精密附件数据库
        dataAccessory: tempDataAccessory,
        // 选定牙位后编辑卡环/连接体的画布图片
        designActiveImg: this.designActiveImg[0],
      }
      // 修改订单 对应订单id/状态/留言
      var id = orderData.servCataId;
      var msg = '您确定生成新订单?';
      if (this.isEditServOrder == '1') {
        let updateForm = '';
        if (sessionStorage.getItem('updateForm')) {
          updateForm = JSON.parse(sessionStorage.getItem('updateForm'))
        };
        orderData.servOrderId = this.$route.query.servOrderId;
        bracketData.id = updateForm.servOrderRpd.id;

        orderData.orderStatus = updateForm.orderStatus;
        orderData.continueDesignMsg = this.ruleForm.content;
        sessionStorage.setItem("orderId", orderData.servOrderId);
        msg = '您将完成对服务单的修改,确定继续服务单【' + updateForm.servOrderNo + '】?';
      }
      console.log('orderData:', orderData);
      console.log('bracketData:', bracketData);
      // return false
      this.$confirm(msg, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true
      }).then(() => {
        this.$api.post({
          url: '/biz/rpdOrder/dem/add?isEditServOrder=' + this.isEditServOrder,
          data: {
            bizServOrder: orderData,
            bizServOrderRpd: bracketData,
            isEditServOrder: this.isEditServOrder
          }
        }).then(res => {
          if (res.code == 200) {
            this.ruleForm.content = '';
            this.loading = false;
            this.msgDialog = false;
            this.$yxz.msg(this.isEditServOrder == '0' ? '生成订单成功' : '修改订单成功', 'success');
            this.$yxz.to('/order/dem');
          } else {
            this.$yxz.msg(res.msg);
          }
        })
      })
    },
    // 控制顶部
    navFixed() {
      if (this.$route.path === '/order/create') {
        var st = document.documentElement.scrollTop || document.body.scrollTop
        st >= 60 ? this.bannerFlag = true : this.bannerFlag = false
      } else {
        return
      }
    },
    open() {
      let singList = this.form.posSingle;
      let steelList = this.steelList;
      let glueList = this.glueList;
      var str = '请再次确认制作' + singList;
      if (steelList && steelList != '') {
        str = '请再次确认制作' + steelList + '钢牙'
      }
      if (glueList && glueList != '') {
        str = '请再次确认制作' + glueList + '充胶牙'
      }
      if (steelList && steelList != '' && steelList && steelList != '') {
        str = '请再次确认制作' + singList + '和' + steelList + '钢牙'
      }
      if (glueList && glueList != '' && singList && singList != '') {
        str = '请再次确认制作' + singList + '和' + glueList + '充胶牙'
      }
      if (glueList && glueList != '' && steelList && steelList != '') {
        str = '请再次确认制作' + steelList + '钢牙和' + glueList + '充胶牙'
      }
      if (singList && steelList && glueList && singList != '' && steelList != '' && glueList != '') {
        str = '请再次确认制作' + singList + '和' + steelList + '钢牙和' + glueList + '充胶牙'
      }
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '重选',
        type: 'warning'
      }).then(() => {
        this.currentStep += 1;
        sessionStorage.setItem('step', this.currentStep)
      }).catch(() => {

      });
    },
    checkValid(currentStep) {
      //定义表单规则
      var rule = [{
        name: 'demContact',
        checkType: 'notnull',
        errorMsg: '请输入下单名称',
        isValid: '1'
      },
      {
        name: 'demPhone',
        checkType: 'phoneno',
        errorMsg: '请输入11位电话号码',
        isValid: '1'
      },
      {
        name: 'demPatient',
        checkType: "notnull",
        errorMsg: '请输入患者姓名',
        isValid: '1'
      },
      {
        name: 'demSex',
        checkType: "notnull",
        errorMsg: '请选择患者性别',
        isValid: '1'
      },
      {
        name: 'orderCount',
        checkType: 'notnull',
        errorMsg: '请先选择牙位图',
        isValid: '1'
      },
      ];
      var rule1 = [
        {
          name: 'dataScan',
          checkType: 'notnull',
          errorMsg: '请上传扫描数据',
          isValid: this.cateserv.isScanData == '1'
        },
        {
          name: 'dataAccessory',
          checkType: 'notnull',
          errorMsg: '请上传精密附件数据库数据',
          isValid: this.form.enclosure ? '1':'0'
        },
      ]
      var rule2 = [
        {
          name: 'designActiveImg',
          checkType: 'notnull',
          errorMsg: '请保存上传牙位图',
          isValid:'1'
        }
      ]
      //isValid字段判断是否需要效验，isValid等于1需要效验，否则不需要效验
      var tempRule = rule.filter((item) => {
        return item.isValid == '1'
      })
      var tempRule1 = rule1.filter((item) => {
        return item.isValid == '1'
      })
      var tempRule2 = rule2.filter((item) => {
        return item.isValid == '1'
      })
      //进行表单检查
      var formData = {
        demContact: this.form.demContact,
        demPhone: this.form.demPhone,
        demPatient: this.form.demPatient,
        demSex: this.form.demSex,
        desLevel: this.form.desLevel,
        orderCount: this.form.orderCount,
        dataScan: this.dataScan,
        dataSheet: this.dataSheet,
        dataMouth: this.dataMouth,
        dataCbct: this.dataCbct,
        dataAccessory:this.dataAccessory,
        designActiveImg:this.designActiveImg
      }
      if (currentStep == 2) {
        var checkRes = graceChecker.check(formData, tempRule);
        if (!checkRes) {
          this.$yxz.msg(graceChecker.error);
          return false
        }
        return true
      } else if (currentStep == 3) {
        var checkRes = graceChecker.check(formData, tempRule2);
        if (!checkRes) {
          this.$yxz.msg(graceChecker.error);
          return false
        }
        return true
      } else if (currentStep == 4) {
        var checkRes = graceChecker.check(formData, tempRule1);
        if (!checkRes) {
          this.$yxz.msg(graceChecker.error);
          return false
        }
        return true
      }
      return false
    },
    // 重置信息
    resetForm() {
      this.currentCatalog = -1;
      this.currentSubCatalog = -1;
      this.subCatalogList = [];
      this.form.demPatient = ''
      this.form.desLevel = '';
      this.form.orderCount = 0;
      this.form.orderPrice = 0.00;
      this.form.toothCountAll = 0;
      this.form.orderRushFee = 0.00;
      this.form.orderAmount = 0.00;
      this.form.orderRemark = '';
      this.form.softType = '';
      this.form.dataType = '';
      this.form.posSingle = '';
      this.form.posBridge = '';
      this.adjunct = '00';
      this.designActiveImg = [];

      this.formData = "";
      this.dataScan = [];
      this.dataSheet = [];
      this.dataMouth = [];
      this.dataCbct = [];
      this.fileList = [];
      this.dataAccessory = [];
      this.cateserv = null;
      this.isEditServOrder = '0'
    },
    change1() {
      this.colorContact = '#2979ff'
    },
    change2() {
      this.colorPhone = '#2979ff'
    },
    change3() {
      this.colorPatient = '#2979ff'
    },
    //从会话存储中加载数据。
    loadFormSession(key, defaultValue) {
      const value = sessionStorage.getItem(key);
      return value !== null ? value : defaultValue;
    },
    //
    loadFormSessionJSON(key, defaultValue) {
      const value = sessionStorage.getItem(key);
      return value !== null && value !== '' && value !== undefined && value !== 'undefined' ? JSON.parse(value) : defaultValue;
    },
    // 统一调用session缓存
    getData() {
      this.$api.get({
        url: '/user/checkLogin'
      }).then(res => {
        this.$store.commit('common/recordDict', res.data.dictList)
        this.$store.commit('common/recordServCata', res.data.servList)
        this.$store.commit('common/recordImplDict', res.data.implList)
      })
      if (this.isEditServOrder == '1') {
        this.subCatalogId = this.loadFormSessionJSON('updateForm', '').servCataId;
      } else {
        this.subCatalogId = this.loadFormSession('subCatalogId', '');
      }
      if (this.subCatalogId) {
        this.nextStep = true;
      }
      this.editCanvas = this.loadFormSessionJSON('editCanvas',this.editCanvas);
      this.currentStep = parseInt(this.loadFormSession('step', 1));
      this.catalogId = this.loadFormSession('catalogId', '');
      this.catalogTitle = this.loadFormSession('catalogTitle', '');
      this.isLevel = this.loadFormSessionJSON('isLevel', false);
      this.remarkHistory = localStorage.getItem('remarkHistory') ? JSON.parse(localStorage.getItem('remarkHistory')) : [];
      this.form = this.isEditServOrder == '1' ? this.loadFormSessionJSON('updateForm', this.form) : this.loadFormSessionJSON('form', this.form);
      this.form.steelCount = this.isEditServOrder == '1' ? this.form.servOrderRpd.steelCount:this.form.steelCount;
      this.form.glueCount = this.isEditServOrder == '1' ? this.form.servOrderRpd.glueCount:this.form.glueCount;
      this.form.enclosure = this.isEditServOrder == '1' ? this.form.servOrderRpd.enclosure:this.form.enclosure;
      if(sessionStorage.getItem('enclosure')){
       this.form.enclosure = sessionStorage.getItem('enclosure')? sessionStorage.getItem('enclosure'):this.form.enclosure;
      }
      this.form.designTray = this.isEditServOrder == '1' ?this.form.servOrderRpd.designTray:this.form.designTray;
      this.form.enclosureCount = this.isEditServOrder == '1' ?this.form.servOrderRpd.enclosureCount:this.form.enclosureCount;

      this.upSelect = this.loadFormSession('upSelect', 0);
      this.downSelect = this.loadFormSession('downSelect', 0);
      this.isCreate = this.loadFormSessionJSON('isCreate', false);
      this.cateserv = this.loadFormSessionJSON('cateserv', []);
      this.teethList = this.loadFormSessionJSON('teethList', this.teethList);
      this.steelList = this.loadFormSessionJSON('steelList', this.steelList);
      this.glueList = this.loadFormSessionJSON('glueList', this.glueList);
      this.canvasImgUrl = this.loadFormSession('canvasImgUrl', this.canvasImgUrl);
      this.designActiveImg = this.loadFormSessionJSON('designActiveImg',this.designActiveImg);

      this.adjunct = '00';
      if (this.form.enclosure != '') {
        this.form.enclosureCount = 1;
      }
      if (this.isEditServOrder == '0') {
        this.dataCbct = this.loadFormSessionJSON('dataCbct', this.dataCbct);
        this.dataScan = this.loadFormSessionJSON('dataScan', this.dataScan);
        this.dataSheet = this.loadFormSessionJSON('dataSheet', this.dataSheet);
        this.dataMouth = this.loadFormSessionJSON('dataMouth', this.dataMouth);
        this.dataScanRod = this.loadFormSessionJSON('dataScanRod', this.dataScanRod);
        this.dataAccessory = this.loadFormSessionJSON('dataAccessory', this.dataAccessory);
      } else if (this.isEditServOrder == '1') {
        let order = this.loadFormSessionJSON('updateForm', [])
        this.dataCbct = this.loadFormSessionJSON('dataCbct', JSON.parse(order.dataCbct));
        this.dataScan = this.loadFormSessionJSON('dataScan', JSON.parse(order.dataScan))
        this.dataSheet = this.loadFormSessionJSON('dataSheet', JSON.parse(order.dataSheet));
        this.dataMouth = order.dataMouth!=''?this.loadFormSessionJSON('dataMouth', JSON.parse(order.dataMouth)):[];
        this.dataScanRod = this.loadFormSessionJSON('dataScanRod', JSON.parse(order.dataScanRod));
        this.dataAccessory = this.loadFormSessionJSON('dataAccessory', JSON.parse(order.servOrderRpd.dataAccessory));
        this.form.posSingle = this.teethList.join(',');
      }
    },
    // 移除session存储的数据
    removeSession() {
      sessionStorage.removeItem('catalogTitle');
      sessionStorage.removeItem('subCatalogId');
      sessionStorage.removeItem('step');
      sessionStorage.removeItem('form');
      sessionStorage.removeItem('catalogId');
      sessionStorage.removeItem('serv');
      sessionStorage.removeItem('isLevel');
      sessionStorage.removeItem('montageStr');
      sessionStorage.clear();
    },
    // 修改订单，读取订单详情信息和设置订单步骤环境
    loadingUp() {
      // 在session中获取详情订单数据
      if (sessionStorage.getItem('updateForm')) {
        var orderDetail = JSON.parse(sessionStorage.getItem('updateForm'));
        this.designActiveImg = orderDetail.servOrderRpd.designActiveImg.split(',');
        this.catalogId = orderDetail.servCataId.slice(0, 2);
        this.subCatalogId = orderDetail.servCataId;
        var id = this.subCatalogId;
        this.teethList = orderDetail.posSingleList?orderDetail.posSingleList.map((item) => parseInt(item)):[];
        this.steelList = orderDetail.steelList?orderDetail.steelList:[];
        this.glueList = orderDetail.glueList?orderDetail.glueList:[];
        this.form.posSingle = orderDetail.posSingleList;
        this.form.steelCount = orderDetail.servOrderRpd.steelList?orderDetail.servOrderRpd.steelList.length:0;
        this.form.glueCount = orderDetail.servOrderRpd.glueList?orderDetail.servOrderRpd.glueList.length:0;
        this.form.steelPrice = (orderDetail.servOrderRpd.steelPrice?orderDetail.servOrderRpd.steelPrice:0).toFixed(2);
        this.form.gluePrice = (orderDetail.servOrderRpd.gluePrice?orderDetail.servOrderRpd.gluePrice:0).toFixed(2);
        this.form.enclosure = orderDetail.servOrderRpd.enclosure;
        this.form.enclosureCount = orderDetail.servOrderRpd.enclosureCount?orderDetail.servOrderRpd.enclosureCount:0;
        this.form.enclosurePrice = (orderDetail.servOrderRpd.enclosurePrice?orderDetail.servOrderRpd.enclosurePrice:0).toFixed(2);
        this.form.designTray = orderDetail.servOrderRpd.designTray?orderDetail.servOrderRpd.designTray:orderDetail.designTray;
        JSON.parse(orderDetail.dataScan).forEach((val, i) => {
          this.dataScan.push(val);
        })
        JSON.parse(orderDetail.dataScanRod).forEach((val, i) => {
          this.dataScanRod.push(val);
        })
        JSON.parse(orderDetail.dataCbct).forEach((val, i) => {
          this.dataCbct.push(val);
        })
        // 详情中的精密附件数据库
        JSON.parse(orderDetail.servOrderRpd.dataAccessory).forEach((val, i) => {
          this.dataAccessory.push(val)
        })
        this.showLevel(id);
        this.forKey(orderDetail, this.form);
        this.nextStep = true;
        this.isEditServOrder = '1';
        this.catalogTitle = orderDetail.servName;
        // 额外适应症选择牙齿的数量
        this.cateserv = this.common.serv.get(id);
        this.titleStr()
        if (this.user.demServType == '00') {
          this.isLevel = true;
        } else {
          this.isLevel = false;
        }
        sessionStorage.setItem('catalogId', this.catalogId);
      }
    },
    //修改服务单时，拼接服务单类型的字符串
    titleStr() {
      let arr1 = ['1010120', '1010210', '1010220', '1010310', '1010320', '1010410', '1010510', '1010698', '1010699', '1010700'];
      let arr2 = ['2010120', '2010210', '2010220', '2010320', '2010420'];
      let arr3 = ['3010130'];
      let arr4 = ['4010110'];
      if (arr1.includes(this.cateserv.servCode)) {
        this.catalogTitle = '数字化种植修复' + ' - ' + this.cateserv.servName;
      } else if (arr2.includes(this.cateserv.servCode)) {
        this.catalogTitle = '数字化固定修复' + ' - ' + this.cateserv.servName;
      } else if (arr3.includes(this.cateserv.servCode)) {
        this.catalogTitle = '数字化正畸修复' + ' - ' + this.cateserv.servName;
      } else if (arr4.includes(this.cateserv.servCode)) {
        this.catalogTitle = '数字化活动修复' + ' - ' + this.cateserv.servName;
      }
      sessionStorage.setItem('catalogTitle', this.catalogTitle);
    },
    // 形参合并相同元素给list2，修改订单：订单详情参数合并给form
    forKey(list1, list2) {
      for (const key1 in list1) {
        for (const key2 in list2) {
          if (key1 === key2) {
            list2[key2] = list1[key2]
          }
        }
      }
    },
    // 在组件挂载DOM树后加载
    think() {
      var id = this.subCatalogId
      var userType = this.user.demServType
      window.addEventListener('scroll', this.navFixed)
      window.addEventListener('resize', this.navFixed)
      document.title = "医小智 - 服务单";
      window.addEventListener('beforeunload', () => {
        if (this.currentStep != 1) {
          if (this.currentStep == '2') {
            this.loadingUp()
          }
          sessionStorage.setItem('form', JSON.stringify(this.form));
          sessionStorage.setItem('editCanvas',JSON.stringify(this.editCanvas));
        }
      });
      // 没有服务类型下一步状态为false
      if (!sessionStorage.getItem('subCatalogId') && !this.subCatalogId) {
        this.nextStep = false
      }
    },
    // 点击历史替换备注
    replaceStr(index) {
      this.form.orderRemark = this.remarkHistory[index];
    },
    // 移除历史备注项
    removeItem(index) {
      this.remarkHistory.splice(index, 1)
      localStorage.setItem('remarkHistory', JSON.stringify(this.remarkHistory))
    },
    /**
     * 初始化子目录显示
     */
    loadSubCatalogByCatalogId() {
      if (this.$route.query.catalogId) {
        this.currentCatalog = Number(this.$route.query.catalogId)
        this.getSubCatalogList(this.currentCatalog)
      }
    },
    /**
     * 获取子目录列表
     * @param {string} currentCatalogIndex - 当前主目录索引
     */
    getSubCatalogList(currentCatalogIndex) {
      // 获取当前主目录的子目录列表
      var tempList = this.catalogList[currentCatalogIndex].subCataLog;
      // 非工厂端，移除工厂端子目录
      if (currentCatalogIndex === 0 && this.user.demServType !== '00') {
        // 种植修复，移除杆卡
        tempList.splice(9, 2);
      } else if (currentCatalogIndex === 1 && this.user.demServType !== '00') {
        // 固定修复，过滤特定子目录
        for (let i = tempList.length - 1; i >= 0; i--) {
          if (tempList[i].subCatalogId === '2010210' || tempList[i].subCatalogId === '2010220') {
            tempList.splice(i, 1);
          }
        }
      }
      this.subCatalogList = tempList; // 更新子目录列表
      this.currentSubCatalog = -1; // 重置子目录选择
    },
    // 处理附件牙位列表拼接
    // 无附件牙位用posSingle字段，钢牙和充胶牙用posBridge字段，用/隔开 '钢牙牙位部分/充胶牙部分'
    // 都为空就是'',其中一个为空去掉斜杠，回显根据钢牙/充胶牙数量判断材质
    // 在提交订单前调用
    handleAnnexTooth() {
      let steel = this.steelList.join(',');
      let glue = this.glueList.join(',');
      this.form.posBridge = steel + '/' + glue;

      if(steel==''){
        this.form.posBridge = glue;
      }else if(glue==''){
        this.form.posBridge = steel;
      }else if(steel!=''&&glue!=''){
        this.form.posBridge = steel + '/' + glue;
      }
    },
    // 移除多余session项
    removeSessionItem() {
      sessionStorage.removeItem('options1');
      sessionStorage.removeItem('options2');
      sessionStorage.removeItem('options3');
      sessionStorage.removeItem('isLevel');
      sessionStorage.removeItem('montageStr');
      sessionStorage.removeItem('isDevicelistShow');
      sessionStorage.removeItem('editModelFee');
      sessionStorage.removeItem('servBridge');
    },
    // 接收传递的画布图片
    canvasToothImg(url) {
      this.designActiveImg = [];
      this.designActiveImg.push(url);
      this.editCanvas = false;
      sessionStorage.setItem('editCanvas',JSON.stringify(this.editCanvas));
      sessionStorage.setItem('designActiveImg', JSON.stringify(this.designActiveImg));
    },
    //传值判断是否操作画布
    corrective(flag){
      this.ruleFlag = flag;
    },
    changeEdit(){
      this.editCanvas = !this.editCanvas;
      sessionStorage.setItem('editCanvas',JSON.stringify(this.editCanvas));
    },
    changeDesignTray(){
      this.$nextTick(()=>{
        let temp = this.cateserv;
        this.form.orderPrice = (this.form.designTray != '02' ? temp.clnBprice : temp.totalDentureDesign).toFixed(2);
        this.calAmount();
      })
    },
    judgeTeeth(){
      // 判断修改牙位时清空原有的图片数组
      if(this.isEditServOrder=='1'){
        let updateForm = JSON.parse(sessionStorage.getItem('updateForm'));
        // posSingle steel glue
        let single = updateForm.posSingleList?updateForm.posSingleList.join(','):'';
        let steelList = updateForm.steelList?updateForm.steelList.join(','):'';
        let glueList = updateForm.glueList?updateForm.glueList.join(','):'';
        let flag1 = single==this.form.posSingle.join(',');
        let flag2 = steelList==this.steelList.join(',');
        let flag3 = glueList==this.glueList.join(',');

        if(!flag1||!flag2||!flag3){
          this.designActiveImg = [];
          sessionStorage.setItem('designActiveImg', JSON.stringify(this.designActiveImg));
          this.editCanvas = true;
        }else{
          this.designActiveImg = updateForm.servOrderRpd.designActiveImg;
          this.editCanvas = false;
        }
        sessionStorage.setItem('editCanvas',JSON.stringify(this.editCanvas));
      }
    },
    resetTeeth(){
      this.$refs.toothComponent.resetAllTeeth();
    },
    undoTeeth(){
      this.$refs.toothComponent.undo();
    },
  },
  created() {
    // 重置form下单方信息
    this.loadOrderParam();
    // 修改订单，读取订单详情信息和设置订单步骤环境
    this.loadingUp();
    // 获取session数据
    this.getData();
    this.catalogList = catalogList;
    this.common.dict.get('biz_des_level').pop();
    this.desLevelMap = this.common.dict.get("biz_des_level")
    this.loadSubCatalogByCatalogId();
    this.$store.commit('common/recordNav', {
      navIndex: 1,
      navSubIndex: 0
    })
    // 重置订单下单方信息
    this.userId = getStore('userId');
    this.loading = false;
  },
  mounted() {
    // 控制顶部
    this.navFixed();
    // 在组件挂载DOM树后加载，刷新前处理
    this.think();
    //创建订单第二步时是否显示设计师级别
    if (this.currentStep == '2') {
      this.showLevel(this.subCatalogId);
    }
    this.removeSessionItem();
  },
  components: {
    BaseTag,
    YButton,
    DTooth,
    InputNum,
    InputField,
    SelectField,
    RadioField,
    InputNumberField,
    BuyNum,
    Customer,
    CanvasBracket
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/style/mixin.scss";


.el-input-contact {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorContact);
  }
}

.el-input-phone {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorPhone);
  }
}

.el-input-patient {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorPatient);
  }
}

.el-input-ordercount {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorOrderCount);
  }
}

.el-input-orderamount {
  .el-input /deep/ .el-input__inner {
    color: var(--inputColorOrderAmount);
  }
}

.order {
  display: flex;
  flex-direction: column;
  perspective: 3000px;
  position: relative;
  z-index: 19;
  margin: 10px auto;
}

.order-box {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 19;
  background: #f7f7f7;
  border-radius: 8px;
}

.order-step {
  position: relative;
  overflow: hidden;
  background: #f7f7f7;
  border-radius: 8px 8px 0 0;
  border-color: rgba(0, 0, 0, .14);
  box-shadow: rgba(0, 0, 0, .06) 1px 1px 7px;
  height: 48px;
  line-height: 48px;
  font-size: 15px;
  color: #626262;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  z-index: 10;

  .order-step-wrap {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
      margin-right: 10px;
    }

  }

}

.order-ops {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  height: 70px;
  background: #f7f7f7;
  border-radius: 0 0 8px 8px;
  border-color: rgba(0, 0, 0, .14);
  box-shadow: rgba(0, 0, 0, .06) 0 1px 7px;
}

.order-detail-catalog {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
}

.order-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  height: 58px;
  width: 100%;

  >span {
    // font-size: 18px;
  }
}

.order-catalog {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 25vh;

  .box {
    overflow: hidden;
    position: relative;
    z-index: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
  }

  .content {
    float: left;
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, .08);
    border-radius: 8px;
  }

  .content ::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    content: "";
    pointer-events: none;
  }

  .i {
    width: 180px;
    height: 120px;
    border-radius: 8px;
  }

  .cover-link {
    cursor: pointer;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4;
    background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
    border-radius: 8px;
  }

  a {
    cursor: pointer;
    transition: all .15s ease-out;
    text-decoration: none;
  }

  a:hover {
    box-shadow: inset 0 0 38px rgba(0, 0, 0, .18);
    transition: all .15s ease;
  }

  .active {
    color: rgba(0, 160, 226, 1);
    border: 1px solid rgba(0, 160, 226, 0.58);
    border-radius: 8px;
  }

  span {
    line-height: 60px;
    text-align: center;
    font-size: 16px;
  }

}

.order-sub-catalog {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .box {
    align-self: center;
    margin: 0 36px;
  }

  .content {
    position: relative;
    float: left;
    width: 160px;
    height: 160px;
    margin: 5px 10px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, .08);
  }

  .content ::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    content: "";
    pointer-events: none;
  }

  .sub-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .i {
    width: 110px;
    height: 110px;
    border-radius: 8px;
  }

  span {
    width: 100%;
    text-align: center;
    font-size: 13px;
    margin-top: 10px;
  }

  .cover-link {
    cursor: pointer;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 4;
    background: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///////yH5BAEHAAEALAAAAAABAAEAAAICTAEAOw==) repeat;
    border-radius: 8px;
  }

  a {
    cursor: pointer;
    transition: all .15s ease-out;
    text-decoration: none;
  }

  a:hover {
    box-shadow: inset 0 0 38px rgba(0, 0, 0, .18);
    transition: all .15s ease;
  }

  .active {
    color: rgba(0, 160, 226, 1);
    border: 1px solid rgba(0, 160, 226, 0.58);
    border-radius: 8px;
  }

}

.step-active {
  color: rgba(0, 160, 226, 1);
}

.order-detail-design {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 30px;
  box-sizing: border-box;
}

.order-design-image {
  width: 50%;
  height: auto;
  margin-top: -130px;
}

.order-design-info {
  width: 50%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.order-basic-wrap {
  // flex: 1;
  width: 100%;
}

.order-input-wrap {
  // flex: 1;
  width: 100%;
  position: relative;
}

.input-form-wrap,
.input-form-wrap-row {
  float: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-family: "宋体", Arial, sans-serif;
}

// 输入框
.input-form-wrap {
  width: 49%;
  padding: 3px 10px;
  font-size: 13px;

  /deep/ .input-label {
    text-align: left !important;
    width: 120px;
  }
}

.input-form-wrap-row {
  width: 49%;
  padding: 10px 10px;
  font-size: 13px;
  margin-left: 1%;

  /deep/ .input-label {
    width: 120px;
    text-align: left !important;
  }
}


.input-textarea {
  padding: 5px 10px;
}

.item-history {
  display: flexbox;
  width: 100%;
  padding: 5px 10px;
}

.order-detail-upload {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 30px;
}

.order-upload-wrap {
  display: flex;
  flex-direction: column;
  padding: 0 30px;
}

.order-file-wrap {
  height: 120px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, .1);
  padding: 10px;
  margin: 15px 0;
}

.upload-file {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.upload-file-dragger1 {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 28px;
  color: #8c939d;
  margin-right: 80px;

  &:hover {
    border-color: #20a0ff;
  }
}

.title-little {
  margin-left: 20px;
}

/deep/.el-select-dropdown__item {
  display: block !important;
}

#clinic {
  margin-left: 40px;
  margin-right: 10px;
}

#factory {
  margin-left: 41px;
}

.el-icon-plus:before {
  line-height: 3;
}
/* 自定义复选框样式 */
.custom-checkbox,
.custom-box {
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #ccc;
  position: relative;
  margin-right: 8px;
}

/* 当复选框选中时的样式 */
.custom-checkbox:checked::before {
  content: '';
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 5px solid #00A5D5;
  margin: -1px;
}

.custom-checkbox:hover {
  border: 1px solid #00A5D5;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// orderCreateBracket.vue?5e101877